import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import cc from 'classcat';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import { useQuery } from 'urql';
import css from './Shops.module.scss';
import Accordion from '../Accordion';
import { Image } from '@outdoor-voices/ui';
import LinkBlocks from '../LinkBlocks';
import Pin from '../icons/Pin';
import Spinner from '../icons/Spinner';
import ShopsHeader from '../ShopsHeader';
import { getShops } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ComingSoon = function ComingSoon(_ref) {
  var items = _ref.items,
      num = _ref.num;
  var props = {
    headlineCenter: true,
    iconLarge: true,
    items: items,
    num: num,
    showImages: false,
    title: 'Coming Soon'
  };
  return /*#__PURE__*/_jsx("section", {
    children: /*#__PURE__*/_jsx(Accordion, _objectSpread({}, props))
  });
};

ComingSoon.propTypes = {
  items: PropTypes.array.isRequired,
  num: PropTypes.number.isRequired
};

var Shop = function Shop(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      city = _ref2.city,
      comingSoon = _ref2.comingSoon,
      phoneNumber = _ref2.phoneNumber,
      streetAddress = _ref2.streetAddress,
      state = _ref2.state,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      image = _ref2.image,
      url = _ref2.url,
      zipCode = _ref2.zipCode;

  var shop = /*#__PURE__*/_jsxs("div", {
    className: css.shopInfoWrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.imgWrap,
      children: /*#__PURE__*/_jsx("a", {
        "aria-hidden": "true",
        href: url,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          className: css.img,
          alt: "".concat(title, " Shopfront"),
          sizes: [300, 430, 452]
        }))
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.shopInfo,
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.titleWrapper,
        children: [/*#__PURE__*/_jsx(Pin, {
          color: backgroundColor
        }), /*#__PURE__*/_jsx("a", {
          href: url,
          children: /*#__PURE__*/_jsx("h3", {
            className: css.title,
            children: title
          })
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: cc([css.subtitle, _defineProperty({}, css.soon, comingSoon)]),
        children: comingSoon ? 'Coming Soon' : subtitle
      }), !comingSoon && /*#__PURE__*/_jsx("p", {
        className: css.phoneNumber,
        children: /*#__PURE__*/_jsx("a", {
          href: "tel:".concat(phoneNumber),
          children: phoneNumber
        })
      }), /*#__PURE__*/_jsx("p", {
        className: css.streetAddress,
        children: /*#__PURE__*/_jsx("a", {
          href: "https://maps.google.com/?q=Outdoor Voices,".concat(streetAddress, " ").concat(city, ", ").concat(state, " ").concat(zipCode),
          children: streetAddress
        })
      })]
    })]
  });

  return /*#__PURE__*/_jsx("li", {
    className: css.shop,
    children: shop
  });
};

Shop.defaultProps = {
  comingSoon: false,
  url: false
};
Shop.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
  image: PropTypes.shape().isRequired,
  phoneNumber: PropTypes.string.isRequired,
  streetAddress: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  zipCode: PropTypes.string.isRequired
};

var Shops = function Shops(_ref4) {
  var description = _ref4.description,
      title = _ref4.title,
      shops = _ref4.shops,
      shopPageArticles = _ref4.shopPageArticles;
  var ACCORDION_THRESHOLD = 2;
  var comingSoonNum = shops.filter(function (shop) {
    return shop.comingSoon === true;
  }).length;
  var showComingSoonAccordion = comingSoonNum >= ACCORDION_THRESHOLD;
  var comingSoonShopsData = [];

  var alphabetize = function alphabetize(shop1, shop2) {
    return shop1.title > shop2.title ? 1 : -1;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(ShopsHeader, {
      title: title,
      subtitle: description
    }), /*#__PURE__*/_jsx("section", {
      className: css.section,
      children: /*#__PURE__*/_jsx("ul", {
        className: css.list,
        children: shops.sort(alphabetize).map(function (_ref5) {
          var accentColor = _ref5.accentColor,
              backgroundColor = _ref5.backgroundColor,
              city = _ref5.city,
              comingSoon = _ref5.comingSoon,
              description = _ref5.description,
              id = _ref5.id,
              image = _ref5.image,
              phoneNumber = _ref5.phoneNumber,
              state = _ref5.state,
              streetAddress = _ref5.streetAddress,
              subtitle = _ref5.subtitle,
              title = _ref5.title,
              url = _ref5.url,
              zipCode = _ref5.zipCode;

          if (comingSoon && showComingSoonAccordion) {
            comingSoonShopsData.push({
              id: (comingSoonShopsData.length + 1).toString(),
              accentColor: accentColor,
              backgroundColor: backgroundColor,
              copy: description,
              cta: 'Learn More',
              icon: ReactDOMServer.renderToString( /*#__PURE__*/_jsx(Pin, {})),
              title: title,
              url: url
            });
            return;
          }

          return /*#__PURE__*/_jsx(Shop, {
            backgroundColor: backgroundColor,
            city: city,
            comingSoon: comingSoon,
            image: image,
            phoneNumber: phoneNumber,
            state: state,
            streetAddress: streetAddress,
            subtitle: subtitle,
            title: title,
            url: url,
            zipCode: zipCode
          }, id);
        })
      })
    }), showComingSoonAccordion && /*#__PURE__*/_jsx(ComingSoon, {
      items: comingSoonShopsData,
      num: comingSoonNum
    }), /*#__PURE__*/_jsx("section", {
      className: css.section,
      children: /*#__PURE__*/_jsx(LinkBlocks, {
        items: shopPageArticles
      })
    })]
  });
};

Shops.propTypes = {
  description: PropTypes.string.isRequired,
  shops: PropTypes.arrayOf(PropTypes.shape(Shop.propTypes)).isRequired,
  shopPageArticles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  title: PropTypes.string.isRequired
};

var ShopsLoader = function ShopsLoader() {
  var _useQuery = useQuery({
    query: getShops
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      "aria-busy": "true",
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  var allShops = data.shops,
      _data$shopsLandingPag = data.shopsLandingPage,
      title = _data$shopsLandingPag.title,
      description = _data$shopsLandingPag.description,
      shopPageArticles = data.shopPageArticles;
  var shops = allShops.edges.map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  return /*#__PURE__*/_jsx(Shops, {
    description: description,
    shops: shops,
    shopPageArticles: shopPageArticles,
    title: title
  });
};

export default ShopsLoader;